import ApiService from '@/services/api.service'
import type { AxiosResponse } from 'axios'
import type { EmptyDataResponse } from '@/types/services/common'
import type {
  FAQResponse,
  LatestVersionResponse,
  ReleaseNotesResponse,
} from '@/types/services/system'
export class SystemService {
  static getLatestVersion(): Promise<AxiosResponse<LatestVersionResponse>> {
    return ApiService.get(`/version.json?_=${Date.now()}`)
  }

  static getReleaseNotes(
    until_tag?: string | null
  ): Promise<AxiosResponse<ReleaseNotesResponse>> {
    let url = '/api/v1/release_notes'
    if (until_tag) {
      url += `?until_tag=${until_tag}`
    }
    return ApiService.get(url)
  }

  static postBugReport(
    name: string,
    description: string,
    send_tg_info = true
  ): Promise<AxiosResponse<EmptyDataResponse>> {
    return ApiService.post('/api/v1/bug_reporting', {
      name,
      description,
      send_tg_info,
    })
  }

  static getFAQ(): Promise<AxiosResponse<FAQResponse>> {
    return ApiService.get('/api/v1/faq')
  }

  static postFAQQuestion(
    message: string
  ): Promise<AxiosResponse<EmptyDataResponse>> {
    return ApiService.post('/api/v2/general/faq/ask-question', {
      message,
    })
  }
}
